import { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import styles from '../styles/loginForm.module.css';
import { API_URL } from '../config/api';

const clearSpecialChars = (value) => value.replace(/[^a-zA-Z0-9]/g, '');

const LoginForm = ({ onLogin }) => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const [newPassword, setNewPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');

  const [token, setToken] = useState(null);
  const [needChangePassword, setNeedChangePassword] = useState(false);

  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess('');
    setLoading(true);

    try {
      const result = await onLogin(login, password);

      if (result?.temp_password === true) {
        setToken(result.token);
        setNeedChangePassword(true);
        setPassword('');
      }
    } catch {
      setErrors(['Неверный логин или пароль']);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess('');

    const validationErrors = [];

    if (newPassword.length < 6) {
      validationErrors.push('Пароль слишком короткий (минимум 6 символов)');
    }

    if (!/[A-Z]/.test(newPassword)) {
      validationErrors.push('Пароль должен содержать хотя бы одну заглавную букву');
    }

    if (newPassword !== repeatPassword) {
      validationErrors.push('Пароли не совпадают');
    }

    if (validationErrors.length) {
      setTimeout(() => setErrors(validationErrors), 10);
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/account/password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password: newPassword }),
      });

      if (!res.ok) throw new Error();

      setNeedChangePassword(false);
      setLogin('');
      setPassword('');
      setNewPassword('');
      setRepeatPassword('');
      setToken(null);

      setTimeout(() => {
        setSuccess('Пароль успешно сменён. Войдите в систему.');
      }, 10);
    } catch {
      setTimeout(() => setErrors(['Ошибка при смене пароля']), 10);
    }
  };

  return (
    <form
      className={styles.form}
      onSubmit={needChangePassword ? handleChangePassword : handleSubmit}
    >
      <img src="/iconGM.png" alt="Логотип" className={styles.logo} />

      {!needChangePassword ? (
        <>
          <h2 className={styles.title}>Добро пожаловать!</h2>

          <input
            className={styles.input}
            type="text"
            placeholder="Логин"
            value={login}
            onChange={(e) => setLogin(clearSpecialChars(e.target.value))}
          />

          <div className={styles.passwordWrapper}>
            <input
              className={styles.inputSecond}
              type={showPassword ? 'text' : 'password'}
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(clearSpecialChars(e.target.value))}
            />
            <button
              type="button"
              className={styles.showPasswordBtn}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
            </button>
          </div>

          <button className={styles.button} type="submit" disabled={loading}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </>
      ) : (
        <>
          <h2 className={styles.title}>Смена пароля</h2>

          <div className={styles.passwordWrapper}>
            <input
              className={styles.inputSecond}
              type={showNewPassword ? 'text' : 'password'}
              placeholder="Новый пароль"
              value={newPassword}
              onChange={(e) =>
                setNewPassword(clearSpecialChars(e.target.value))
              }
            />
            <button
              type="button"
              className={styles.showPasswordBtn}
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {showNewPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
            </button>
          </div>

          <div className={styles.passwordWrapper}>
            <input
              className={styles.inputSecond}
              type={showRepeatPassword ? 'text' : 'password'}
              placeholder="Повторите пароль"
              value={repeatPassword}
              onChange={(e) =>
                setRepeatPassword(clearSpecialChars(e.target.value))
              }
            />
            <button
              type="button"
              className={styles.showPasswordBtn}
              onClick={() => setShowRepeatPassword(!showRepeatPassword)}
            >
              {showRepeatPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
            </button>
          </div>

          <button className={styles.button} type="submit">
            Сохранить пароль
          </button>
        </>
      )}

      <div className={styles['toast-container']}>
        {errors.map((err, idx) => (
          <div key={idx} className={`${styles.toast} ${styles.error}`}>
            {err}
          </div>
        ))}

        {success && (
          <div className={`${styles.toast} ${styles.success}`}>
            {success}
          </div>
        )}
      </div>
    </form>
  );
};

export default LoginForm;
